
<template>
	<setup_content title="Подбор объектов-аналогов">
		<setAnalogue ref="set_analogue" :id="id" v-on:need_refresh="() => refresh()" v-on:set_many="do_set_analogue_many"/>

		<elements
			v-if="group_id"
			ref="objects"
			service="cadastral_objects"
			without_add
			without_back_button
			:attrs="attrs"
			:get_many_extra="{ group : group_id, registry : 'default' }"
			not_able_for_delete
			emit_on_double_click_element
			essence_name_genetive_case="объекта"
			essence_name_for_plural_1="объект"
			essence_name_for_plural_234="объекта"
			essence_name_for_plural_others="объектов"
			:elements_table_height="elements_table_height"
			postfix_for_storage_name="expense_analogue_selection"
			without_edit_many
			without_copy
			initial_per_page="5"
			:without_context_menu="!check_roles([ 'model' ])"
		>
			<template v-slot:title><h4>Объекты оценки</h4></template>

			<template v-slot:first_nav_items>
				<b-button v-if="check_roles([ 'model' ])" v-on:click="set_analogue_auto" variant="outline-primary-secondary">
					<span>Автоматический подбор объекта-аналога</span><base-icon name="aoa" size="md" />
				</b-button>
				<b-button v-if="check_roles([ 'model' ])" v-on:click="set_analogue_many" variant="outline-primary-secondary">
					<span>Подбор объекта-аналога</span><base-icon name="tune" size="md" />
				</b-button>
			</template>

			<template v-slot:nav_items_before_export>
				<b-button v-if="check_roles([ 'model' ])" v-on:click="delete_analogue_many" v-b-tooltip:fullscreen.hover.bottomright title="Удаление объекта-аналога" variant="outline-danger">
					<base-icon name="delete" />
				</b-button>
			</template>
	
			<template v-slot:activities="selected_element">
				<b-dropdown-item v-if="check_roles([ 'model' ])" v-on:click="set_analogue(selected_element.data)">Подобрать объект-аналог</b-dropdown-item>
			</template>

			<template v-slot:table_cell_params="cell_data">
				<b-button v-if="check_roles([ 'model' ])" v-b-tooltip:fullscreen.hover.bottomright="'Подобрать объект-аналог'" size="sm" variant="outline-primary-dark" v-on:click="set_analogue(cell_data.data.item)">
					<base-icon name="tune" />
				</b-button>
			</template>
	
		</elements>
		
		<setup_frame title="Статистика">
			<statistic :total="objects_count"
				:stats="[['', objects_count - ( not_found_count == null ? objects_count : not_found_count )]]"
				:warning="!!(not_found_count == null ? objects_count : not_found_count)"
				good_stat_legend="Объект-аналог найден"
				bad_stat_legend="Объект-аналог не найден"
			>
                <template v-slot:warning>
                    <div style="line-height: 1.5rem;">
                        Для части объектов оценки отсутствует объект-аналог.
						<!-- <br>Выберите для объектов оценки объект-аналог <i>вручную</i> -->
                    </div>
                </template>
            </statistic>
		</setup_frame>
	</setup_content>
</template>

<script>

import elements from "../../../../elements"
import api from "../../../../../api"
import setAnalogue from "./modal/set_analogue"
import setup_content from "../setup_assets/content"
import setup_frame from "../setup_assets/frame"
import statistic from "../setup_assets/statistic"

var attrs =
	[
		{
			attr_key : "attrs.CadastralNumber",
			visible : true,
			visible_if_no_visible : true,
			is_cadastral_number : true,
		},
		{
			attr_key : "attrs.Name",
			visible : true,
			visible_if_no_visible : true,
		},
		{
			attr_key : "attrs.functional_sub_group",
			visible : true,
			visible_if_no_visible : true,
		},
		{
			attr_key : "attrs.Area",
			visible : true,
			visible_if_no_visible : true,
		},
		{
			attr_key : "attrs.code_of_analogue_expensive",
			visible : true,
			visible_if_no_visible : true,
		},
		{
			attr_key : "attrs.cs",
			visible : true,
			visible_if_no_visible : true,
		},
	]

export default
{
	props :
	{
		id : String,
		cost_evaluation : Object,
        group_id : String,
		objects_count : Number,
		not_found_count : Number,
	},

	components :
	{
		elements,
		setAnalogue,
		statistic,
		setup_content,
		setup_frame,
	},

	data()
	{
		return {

			service : "cadastral_cost_evaluation",

			elements_table_height : "100%",

		}
	},

	computed:
	{
		attrs() {
			if (this.check_roles([ 'model' ])) {
				return [
					{
						key : "settings",
						visible : true,
						visible_if_no_visible : true,
						params : true,
						thClass: "cell_settings_head",
						thStyle: "width: 64px;"
					},
					...api.deep_clone(attrs)
				]
			} else {
				return api.deep_clone(attrs)
			}
		}
	},

	methods :
	{
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		refresh()
		{
			this.$refs.objects.refresh()

			this.$emit("need_refresh")
		},

		set_analogue(selected_obj)
		{
			if (this.check_roles([ 'model' ]))
            {
				this.$refs.set_analogue.execute(selected_obj)
			}
		},

		set_analogue_many()
		{
			if (this.check_roles([ 'model' ]))
            {
				this.$refs.set_analogue.execute()
			}
		},

		do_set_analogue_many(analogue_id)
		{
			if (this.check_roles([ 'model' ]))
            {
				const params =
				{
					id : this.id,
					analogue_id : analogue_id,
					query : this.$refs.objects.get_query()
				}
	
				api.call_long_operation(this, "Подбор объектов-аналогов", "cadastral_cost_evaluation", "set_analogue_many_in_comparative_element", params,
					response =>
					{
						api.open_response_url(response)
	
						this.refresh()
					},
					{ success_msg : "Объект-аналог установлен" }
				)
			}
		},

		delete_analogue_many()
		{
			if (this.check_roles([ 'model' ]))
            {
				const params =
				{
					id : this.id,
					query : this.$refs.objects.get_query()
				}
	
				api.call_long_operation(this, "Удаление объектов-аналогов", "cadastral_cost_evaluation", "delete_analogue_many_in_comparative_element", params,
					response =>
					{
						api.open_response_url(response)
	
						this.refresh()
					},
					{ success_msg : "Объекты-аналоги удалены" }
				)
			}
		},

		set_analogue_auto()
		{
			if (this.check_roles([ 'model' ]))
            {
				api.call_long_operation(this, "Автоматический подбор объектов-аналогов", this.service, "set_analogue_auto_in_comparative_element", { id : this.id, query : this.$refs.objects.get_query() }, 
					response =>
					{
						api.open_response_url(response)
	
						this.refresh()
					},
					{ success_msg : "Автоматический подбор объектов-аналогов завершен" }
				)
			}
		},
	}
}

</script>

<style scoped>
* >>> .cell_settings_head
{
	text-align: center;
	width: 4rem;
}
</style>
